import React from 'react';
import styled, { css } from 'styled-components';

type Props = {
  children: React.ReactNode;
  isMobile?: boolean;
};

const SectionTitle = ({ children, isMobile = false }: Props) => {
  return <Title $isMobile={isMobile}>{children}</Title>;
};

const Title = styled.h3<{ $isMobile: boolean }>`
  font-size: 40px;
  line-height: 60px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.colors.topicBlue};
  ${({ $isMobile }) =>
    $isMobile &&
    css`
      font-size: 24px;
      line-height: 35px;
      margin-bottom: 23px;
    `}
`;

export default SectionTitle;
